import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Card } from 'core/components/card';
import { awsDateToStringDate } from 'core/helpers/formatters';
import { track } from 'core/helpers/analytics';
import useSession from 'core/hooks/use-session';
import useBrandFeatures from 'core/hooks/use-brand-features';

import notificationIconWhite from './alert-small-white.svg';
import useStyles from './future-effective-date-warning.styles';

const FutureEffectiveDateWarning = ({ daysOut, isAQDState = false, daysUntilEffective, creationDate }) => {
  const classes = useStyles();
  const { user, isAgency } = useSession();
  const { hasAdvanceQuoteDiscount } = useBrandFeatures();

  const showAQDMessage =
    hasAdvanceQuoteDiscount &&
    isAQDState &&
    creationDate &&
    typeof daysUntilEffective === 'number' &&
    !Number.isNaN(daysUntilEffective) &&
    daysUntilEffective >= 0 &&
    daysUntilEffective < 8;

  const formattedCreationDate = creationDate ? awsDateToStringDate(creationDate.toISOString().slice(0, 10)) : '';

  useEffect(() => {
    if (showAQDMessage) {
      track('Staff Appcues: AQD banner shown in Auto Settings', {
        isAgency,
        affinityCode: user.affinityCode
      });
    }
  }, [showAQDMessage, isAgency, user.affinityCode]);

  let message = '';
  if (showAQDMessage) {
    message = `Policies must start at least ${daysOut} day${
      daysOut === 1 ? '' : 's'
    } in the future. An Advance Quote discount applies for effective dates 3+ days from the offer's creation date (${formattedCreationDate}) and increases for dates 8+ days from the creation date.`;
  } else {
    message = `All policies must be at least ${daysOut} day${daysOut === 1 ? '' : 's'} future effective.`;
  }

  return (
    <Card className={classes.warning}>
      <img src={notificationIconWhite} alt="Notification Icon" />
      {message}
    </Card>
  );
};

FutureEffectiveDateWarning.propTypes = {
  daysOut: PropTypes.number,
  isAQDState: PropTypes.bool,
  daysUntilEffective: PropTypes.number,
  creationDate: PropTypes.instanceOf(Date)
};

FutureEffectiveDateWarning.defaultProps = {
  daysOut: undefined,
  isAQDState: false,
  daysUntilEffective: undefined,
  creationDate: undefined
};

export default FutureEffectiveDateWarning;
